module.exports = __webpack_public_path__ + "static/media/peterArt8.de6fea25.jpg";